const STORAGE_PREFIX = "doitify.tour";

function getUserId() {
  try {
    return localStorage.getItem("UserID") || "guest";
  } catch {
    return "guest";
  }
}

function getKey(tourKey, version) {
  const uid = getUserId();
  return `${STORAGE_PREFIX}.${uid}.${tourKey}.v${version}`;
}

function readTourState(tourKey, version) {
  try {
    const key = getKey(tourKey, version);
    const raw = localStorage.getItem(key);
    if (!raw) return null;
    return JSON.parse(raw);
  } catch {
    return null;
  }
}

function writeTourState(tourKey, version, data) {
  try {
    const key = getKey(tourKey, version);
    const current = readTourState(tourKey, version) || {};
    localStorage.setItem(
      key,
      JSON.stringify({
        ...current,
        ...data,
        tourKey,
        version,
        updatedAt: Date.now(),
      })
    );
  } catch {
    // localStorage unavailable
  }
}

export function isTourCompleted(tourKey, version) {
  const data = readTourState(tourKey, version);
  return data?.status === "completed" || data?.status === "skipped";
}

export function isTourSeen(tourKey, version) {
  const data = readTourState(tourKey, version);
  return Boolean(data?.lastPlayedAt);
}

export function markTourStarted(tourKey, version) {
  writeTourState(tourKey, version, {
    status: "started",
    startedAt: Date.now(),
    lastPlayedAt: Date.now(),
  });
}

export function markTourCompleted(tourKey, version, status = "completed") {
  writeTourState(tourKey, version, {
    status,
    finishedAt: Date.now(),
    lastPlayedAt: Date.now(),
  });
}

export function resetTour(tourKey, version) {
  try {
    const key = getKey(tourKey, version);
    localStorage.removeItem(key);
  } catch {
    // localStorage unavailable
  }
}

export function resetAllTours() {
  try {
    const prefix = `${STORAGE_PREFIX}.${getUserId()}.`;
    const keys = [];
    for (let i = 0; i < localStorage.length; i++) {
      const key = localStorage.key(i);
      if (key && key.startsWith(prefix)) {
        keys.push(key);
      }
    }
    keys.forEach((k) => localStorage.removeItem(k));
    return true;
  } catch {
    return false;
  }
}
